module.exports = __webpack_public_path__ + "static/media/icon_c_animated.56a11bad.svg";